import { useState, useEffect } from 'react';
import { Link } from 'react-router';

import { LazyLoadImage } from 'react-lazy-load-image-component';

import contentful from '../../../utils/contentful';
import styles from './Entries.module.scss';

const Entries = ({ limit, query, image, link, caption }) => {

  const [ loading, setLoading ] = useState(false);
  const [ items, setItems ] = useState([]);

  useEffect(() => {

    setLoading(true);

    contentful.client
      .getEntries(query)
      .then(res => {
        setLoading(false);
        setItems(res.items.slice(0, limit));
      })
      .catch(err => {
        setLoading(false);
        setItems([]);
      });

  }, [limit, query]);

  return (
    <div className={styles.root}>

      {
        loading && (
          <div className={styles.loading}>
            Loading...
          </div>
        )
      }

      {
        items.length > 0 && (
          <div className={styles.content}>
            {
              items.map(item => (
                <Link
                  key={item.fields.slug}
                  className={styles.item}
                  aria-label={item.fields.title}
                  to={link(item)}>

                  <div className={`
                    ${styles.image}
                    ${{
                      'cover': styles.cover,
                      'contain': styles.contain,
                    }[image.mode]}
                  `}>

                    <LazyLoadImage
                      src={`https:${item.fields[image.field].fields.file.url}`}
                      alt={
                        item.fields[image.field].fields.description ||
                        item.fields[image.field].fields.title
                      }
                    />
                  </div>

                  <div className={styles.title}>
                    {item.fields.title}
                  </div>

                </Link>
              ))
            }
          </div>
        )
      }

      <div className={styles.action}>
        <Link to={link()}>
          {caption}
        </Link>
      </div>
    </div>
  );
};

export default Entries;